<template>
<section class="display-table ">
    <div class="vertical-align-middle">
        <b-container class="bv-example-row">
            <b-row>
                <b-col cols="4" class="center-col text-center vertical-align-middle">
                    <b-form @submit="onSubmit">
                        <img style="height:80px" class="center-col" src="../assets/logov1.png" />
                        <b-form-group class="padding-nine-top">
                            <b-form-input v-model="form.username" type="text" required placeholder="Enter usermane"></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <b-form-input v-model="form.password" type="password" required placeholder="Enter password"></b-form-input>
                        </b-form-group>

                        <b-button class="width-auto bg-orange" type="submit" variant="primary">Ingresa</b-button>
                        <p class="padding-three-top">
                            En caso de no recordar su contraseña contacta a:
                            <span class="text-orange"> SOPORTE TI</span>
                        </p>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </div>
</section>
</template>

<script>
import axios from "axios";
import {
    mapMutations
} from "vuex";
export default {
    name: "Login",
    data() {
        return {
            form: {
                email: "",
                username: "",
                password: "",
                food: null,
                checked: [],
            },
            foods: [{
                    text: "Select One",
                    value: null
                },
                "Carrots",
                "Beans",
                "Tomatoes",
                "Corn",
            ],
            show: true,
        };
    },
    methods: {
        ...mapMutations("module", ["setAuthToken"]),
        async onSubmit() {
            event.preventDefault()

            try {
                /*  const data = { 
                    usuario: this.form.username,
                    clave: this.form.password,
                    codigo: 1,
                    abreviatura: "SCTRX",
                    host: "0.0.0.0",
                    ip: "0.0.0.0"
                  }; */
                this.$store.commit("SET_LOADING", true);
                let response = await axios
                    .post(
                        "https://apiscaqa.promart.ec/seguridad/acceder", {
                            usuario: this.form.username,
                            clave: this.form.password,
                            codigo: 1,
                            abreviatura: "SCTRX",
                            host: "0.0.0.0",
                            ip: "0.0.0.0",
                        }, {
                            headers: {
                                "Content-type": "application/json"
                            },
                        }
                    )
                console.log(response)
                let options = response.data.poucu_opciones.map((row) => {
                    return {
                        codigo: row.cod_opc,
                        descripcion: row.des_opc,
                        tipo: row.tip_opc,
                        cod_nivel: row.cod_niv2
                    };
                });
                if (response.data.message === "OK") {
                    var obj = {
                        status: true,
                        username: this.form.username
                    };
                    this.$store.commit("module/setAuthToken", obj);
                    this.$store.commit("module/SET_OPTIONS_MENU", options);
                    this.$router.push({
                        path: "/search-ticket"
                    });
                } else {
                    console.log('llegaste')
                    let values = {
                        variant: "danger",
                        msg: 'Credenciales inválidas!'
                    };
                    this.$store.commit("SET_SHOW_ALERT", true);
                    this.$store.commit("SET_MSG_RESPONSE", values);

                }

            } catch (error) {
                console.log(error)
            } finally {
                this.$store.commit("SET_LOADING", false);
                setTimeout(() => this.$store.commit("SET_SHOW_ALERT", false), 2000);
            }

            /* axios
               .post(
                 "http://10.20.12.134:30966/UserAccount/Login",
                 { Username: self.form.username, Password: self.form.password }, // the data to post
                 {
                   headers: {
                     "Content-type": "application/json",
                   },
                 }
               )
               .then((response) => {
                 console.log(response);
                 var obj = { status: true, username: self.form.username };
                 self.$store.commit("module/setAuthToken", obj);
                 this.$router.push({ path: "/search-ticket" });
               })
               .catch((error)=>console.log(error)) */
        },
    },
};
</script>

<style scoped>
.center-col {
    float: none;
    margin-right: auto;
    margin-left: auto;
}

.text-center {
    text-align: center;
}

.padding-nine-top {
    padding-top: 9%;
}

.width-auto {
    width: 100%;
}

.bg-orange {
    background: rgb(254, 123, 1);
}

.padding-three-top {
    padding-top: 3%;
}

.vertical-align-middle {
    display: table-cell;
    vertical-align: middle;
}

.display-table {
    display: table;
    height: 100%;
    background-color: rgb(235, 235, 235);
    width: 100%;
}

.text-orange {
    color: rgb(254, 123, 1);
}
</style>
